export default __webpack_public_path__ + "static/media/save-icon.4a0c8273.svg";